import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updatePerson } from "common/services/persons.service";
import { toast } from "react-toastify";
import ContactDetailsForm from "./ContactDetailsForm";

const UpdateContactDetails: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;

  person: any;
}> = ({ toggle, isModalOpen, person, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const physicalAddress = person?.physicalAddress || [];
  const postalAddress = person?.postalAddress || [];
  const emailAddress = person?.emailAddress || [];
  const phoneNumber = person?.phoneNumber || [];

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      phoneNumber: (phoneNumber.length > 0 &&
        phoneNumber.map((item: any) => item.name)) || [""],
      emailAddress: (emailAddress.length > 0 &&
        emailAddress.map((item: any) => {
          return item.name;
        })) || [""],
      websiteOrLink: person?.websiteOrLink || "",
      postalAddress: (postalAddress.length > 0 &&
        postalAddress.map((item: any) => {
          return {
            address: item.address,
            city: item.city,
            country: item.country,
          };
        })) || [
        {
          address: "",
          city: "",
          country: "",
        },
      ],

      physicalAddress: (physicalAddress.length > 0 &&
        physicalAddress.map((item: any) => {
          return {
            address: item.address,
            city: item.city,
            country: item.country,
          };
        })) || [
        {
          address: "",
          city: "",
          country: "",
        },
      ],
    },
    validationSchema: Yup.object({
      phoneNumber: Yup.array().of(Yup.string()),
      emailAddress: Yup.array().of(Yup.string()),
      website: Yup.string().nullable(),
      physicalAddress: Yup.array().of(
        Yup.object({
          city: Yup.string().nullable(),
          country: Yup.string().nullable(),
          address: Yup.string().nullable(),
        })
      ),
      postalAddress: Yup.array().of(
        Yup.object({
          city: Yup.string().nullable(),
          country: Yup.string().nullable(),
          address: Yup.string().nullable(),
        })
      ),
    }),
    onSubmit: (values: any) => {
      values["physicalAddress"] = values["physicalAddress"].filter(
        (el: any) => el.city !== "" || el.country !== "" || el.address !== ""
      );
      values["postalAddress"] = values["postalAddress"].filter(
        (el: any) => el.city !== "" || el.country !== "" || el.address !== ""
      );

      const data = {
        id: person.id,
        data: {
          phoneNumber:
            Array.isArray(values["phoneNumber"]) &&
            values["phoneNumber"].length > 0
              ? values["phoneNumber"]
                  .map((el) => {
                    if (el !== "") {
                      return {
                        name: el,
                      };
                    }
                    return null;
                  })
                  .filter((el) => el !== null)
              : [],
          emailAddress:
            Array.isArray(values["emailAddress"]) &&
            values["emailAddress"].length > 0
              ? values["emailAddress"]
                  .map((el) => {
                    if (el !== "") {
                      return {
                        name: el,
                      };
                    }
                    return null;
                  })
                  .filter((el) => el !== null)
              : [],
          website: values["website"],
          physicalAddress: values["physicalAddress"],
          postalAddress: values["postalAddress"],
        },
      };

      setLoading(true);
      const saveData = async () => {
        try {
          await updatePerson(data);
          validation.resetForm();
          toggle();
          toast.success("Contact Details Updated Successfully", {
            autoClose: 1000,
          });
        } catch (err: any) {
          toast.error("Error while updating contact details", {
            autoClose: 1000,
          });
        } finally {
          setLoading(false);
          fetchData();
        }
      };
      saveData();
    },
  });

  return (
    <Modal
      id="showModal"
      size="xl"
      isOpen={isModalOpen}
      toggle={() => {
        toggle();
        validation.resetForm();
      }}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Contact Details
      </ModalHeader>

      <ContactDetailsForm
        toggle={toggle}
        validation={validation}
        isUpdate
        loading={loading}
        setLoading={setLoading}
      />
    </Modal>
  );
};

export default UpdateContactDetails;
